module.exports = __webpack_public_path__ + "static/img/jyjk.eff9c61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/jyjk.png
// module id = kmNm
// module chunks = 44